import { Component } from '@angular/core';
import { ActionSheetController,IonicPage, NavController,AlertController, LoadingController, NavParams,ModalController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { CommonProvider } from '../../providers/common/common';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {FileuploadPage} from "../fileupload/fileupload"

/**
 * Generated class for the UpdatepersonaleditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-updatepersonaledit',
  templateUrl: 'updatepersonaledit.html',
})
export class UpdatepersonaleditPage {
  objModel:any={};
  salution:any;
  maritalstatus:any;
  ibhfl_documentchecklist:any;
  errorDisplay:any={};
  documnetTypes:any=[];
  request:any={};
  marital_status_value:any;
  salution_value:any;
  buttonDisabledSalutation:any;
  buttonDisabledMarital:any

  documentArr:any={};
   constructor(private fv : GenericFormValidationProvider,
    public modalCtrl: ModalController,public actionSheetCtrl: ActionSheetController,public navCtrl: NavController, public navParams: NavParams,
     
     
    private alertController: AlertController,
    
    private loadingCtrl: LoadingController,public cp:CommonProvider)  {
    this.salution=this.navParams.get("queryParams").ibhfl_salutation_FormattedValue;
     
    this.maritalstatus=this.navParams.get("queryParams").ibhfl_maritalstatus_FormattedValue;
    this.marital_status_value=parseInt(this.navParams.get("queryParams").ibhfl_maritalstatus);
    this.salution_value=parseInt(this.navParams.get("queryParams").ibhfl_salutation);
    this.buttonDisabledSalutation=parseInt(this.navParams.get("queryParams").ibhfl_salutation);
    this.buttonDisabledMarital=parseInt(this.navParams.get("queryParams").ibhfl_maritalstatus);
    

  }

  ionViewDidLoad() {
     
    this.objModel = this.navParams.get("queryParams");
    this.ibhfl_documentchecklist=""; 
    this.getDocumentType();
     
  }
  uploadDocument(doc_type?:any){

  const modal = this.modalCtrl.create(FileuploadPage,{showBackdrop: false,
                      enableBackdropDismiss: false});
            modal.onDidDismiss((fetchFileData) => {
              
              if(!fetchFileData){

              }else{
                console.log(fetchFileData,"fetchFileDatafetchFileDatafetchFileData");
                this.documentArr=fetchFileData.document;
              }
            })
            modal.present()
}
  getDocumentType(){
    let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
    loading.present()
    this.cp.getDocumentTypeMaster(loading).then((res:any)=>{
      loading.dismiss()
      var res=JSON.parse(res)
       this.documnetTypes=res;
      console.log(res)
    })
  }
   presentActionSheet(title?:any,msg?:any) {
    const actionSheet = this.actionSheetCtrl.create({
      title: msg,
      cssClass: 'commanSheet',
      buttons: [
        {
          text: "OK",
          role: 'Ok',
          handler: () => {
             actionSheet.dismiss();
              
          }
        }
      ]
    });
    actionSheet.present();
  } 
  updateInfo(sal){
     
    this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
       
      if(this.errorDisplay.valid){
        return false;
      }else{

        console.log(this.documentArr);

          if(!this.documentArr.name){
            this.errorDisplay.document="Please upload file";
            // this.presentActionSheet("Error","Please upload file");
            return false;
          }

          if(sal=='maritalstatus' && this.marital_status_value==this.buttonDisabledMarital){
            this.presentActionSheet("Error","The marital status you are trying to enter is the same as the one our records. Please enter a different marital status.");
            return false;
          }else if(sal=='salution' && this.salution_value==this.buttonDisabledSalutation){
            this.presentActionSheet("Error","The salutation you are trying to enter is the same as the one our records. Please enter a different salutation.");
            return false;
          }else{
             if(sal=='salution')
              {
                    this.request={
                        "ibhfl_customerloanid": localStorage.getItem("ibhfl_customerloanid"),
                        "customerid": JSON.parse(localStorage.getItem("existingLoan"))[0].customercode,
                        "ibhfl_salutation": this.salution_value,
                        "ibhfl_documentchecklist": this.ibhfl_documentchecklist
                    } 
              }else{
                      this.request={
                          "ibhfl_customerloanid": localStorage.getItem("ibhfl_customerloanid"),
                          "customerid": JSON.parse(localStorage.getItem("existingLoan"))[0].customercode,
                          "ibhfl_maritalstatus": this.marital_status_value,
                          "ibhfl_documentchecklist": this.ibhfl_documentchecklist
                      }
              }
          
               
              let loading = this.loadingCtrl.create({
                      content: 'Please wait...'
                    });
              loading.present()
              this.cp.postMaritalSatus(loading,this.request).then((res:any)=>{
                
                var res=JSON.parse(res);
                
                if(!res.Payload){
                  loading.dismiss()
                   
                 this.presentActionSheet("Error",res.Message)
                }else{
                  
                   let reqCaseGuid:any={};
                 reqCaseGuid.CaseGuidValue = res.Payload.caseguid;
                this.cp.postDetdocumentchecklist(loading,reqCaseGuid).then((resp:any)=>{
                  //loading.dismiss()
                   
                  var resp=JSON.parse(resp);
                  let reqU:any={};
                  reqU.documentchecklistid=resp.Payload.Details.ccs_documentchecklistid;
                  
                  this.cp.postUploadDocumentchecklist(loading,reqU,this.documentArr).then((respp:any)=>{
                      
                      loading.dismiss()
                      this.presentActionSheet("Your SR number "+res.Payload.caseid+" has been resolved.")
                  })
                })
                console.log(res)
                }
                
              })
          }
             
      }

    //this.presentActionSheet("Success","Your request has been submitted successfully")
    
  }

  changeSalutation(value){
    
    this.salution_value=parseInt(value);
     

  } 
  changeMaritalStatus(value){
     this.marital_status_value=parseInt(value);

  } 

}



// WEBPACK FOOTER //
// ./src/pages/updatepersonaledit/updatepersonaledit.ts